export enum ItsmNames {
    jira = 'JIRA',
    serviceNow = 'Service Now',
}

export enum monitorinServices {
    airflow="Airflow"
}
